import { type Institute, InstitutesService } from '@api-client/info-services';
import { createQuery } from '@luna/api';
import { getFeatureConfig } from '@luna/feature-config';

const INSTITUTES_EMPTY_ARRAY: Institute[] = [];

export const [useInstitutes] = createQuery<() => Promise<Institute[]>>({
    name: 'institutes',
    condition: () => getFeatureConfig(({ infoApi }) => infoApi.fetchInstitutes),
    payloadCreator: async () => {
        const { institutes } = await InstitutesService.getInfoInstitutes1();

        return institutes ?? INSTITUTES_EMPTY_ARRAY;
    },
});
